import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import StandardModal, { useModalLoading } from "./StandardModal";
import axios from "axios";
import { nowOperationalDateString } from "../../utils/operationalDateTime";
import { useT } from '../../i18n';


interface MyModalProps {
  isOpenAbono: boolean;
  onCloseAbono: () => void;
  onButtonClickAbono: () => void;
  id: string;
}

const ModalAbonos: React.FC<MyModalProps> = ({
  isOpenAbono,
  onCloseAbono,
  onButtonClickAbono,
  id,
}) => {
  const t = useT();
  const [, setLoan] = useState([]);
  // Cargando propio del modal mientras se consulta el préstamo.
  const { loading, showLoading, hideLoading } = useModalLoading();
  const [, setLoanPayments] = useState([]);

  const [idNumber, setIdNumber] = useState("");
  const [, setFullName] = useState("");
  const [, setMobilePhone] = useState("");
  const [, setMainAddress] = useState("");

  const [date, setDate] = useState("");
  const [fecha, setFecha] = useState("");
  const [, setValue] = useState("");
  const [totalValue, setTotalValue] = useState("");
  const [, setInstallmentValue] = useState("");
  const [, setTermDays] = useState("");
  const [abono, setAbono] = useState("");
  const aboNum = parseInt(abono);
  const totalNum = parseInt(totalValue);
  const pendiente = totalNum - aboNum;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const paymentsData = await axios.get(`loans/${id}/payments`);
        setLoanPayments(paymentsData.data);
      } catch (error) {
        console.error("Error fetching loan payments data:", error);
      }
    };

    const fetchData2 = async () => {
      try {
        const loanData = await axios.get(`loans/${id}`);

        setLoan(loanData.data);
        setIdNumber(loanData.data.client.idNumber);
        setFullName(loanData.data.client.fullName);
        setMobilePhone(loanData.data.client.mobilePhone);
        setMainAddress(loanData.data.client.mainAddress);
        setDate(loanData.data.date);
        setValue(loanData.data.value);
        setTotalValue(loanData.data.totalValue);
        setInstallmentValue(loanData.data.installmentValue);
        setTermDays(loanData.data.termDays);
      } catch (error) {
        console.error("Error fetching loan data:", error);
      }
    };

    if (isOpenAbono) {
      showLoading();
      Promise.all([fetchData(), fetchData2()]).finally(hideLoading);
    }
  }, [isOpenAbono, id, showLoading, hideLoading]);

  return (
    <StandardModal
      open={isOpenAbono}
      onClose={onCloseAbono}
      title={t('payments.dateChange.title', { idNumber })}
      maxWidth={800}
      loading={loading}
      actions={
        <>
          <span />
          <Button variant="contained" size="small" onClick={onButtonClickAbono}>
            {t('payments.quick.close')}
          </Button>
        </>
      }
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="date"
            label={t('payments.dateChange.current')}
            id="idnumber"
            value={date}
            onChange={(event) => setDate(event.target.value)}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="date"
            label={t('payments.dateChange.new')}
            value={fecha || " "}
            onChange={(event) => setFecha(event.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ max: nowOperationalDateString() }}
          />
        </Grid>
      </Grid>
    </StandardModal>
  );
};

export default ModalAbonos;
